import { useApplicationConfig } from '@bonusly/application';

import { useURLBuilder } from './use-url-builder';

export const useBuildRecognizeURL = () => {
	const base = useApplicationConfig('recognizeOrigin');
	return useURLBuilder(base);
};
